import styled from "styled-components";

export const InputMonthYearContainer = styled.div`
  input:disabled {
    cursor: not-allowed;
  }
`;
